<style scoped>
    @import url("../../styles/smartControl/execSC.scss");
</style>

<template>
    <div class="box_execSC">

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-timer-settings-outline</v-icon>
            <span class="ml-2">Execução</span>
        </div>

        <div class="painelGeral" v-if="flagMsgSistema">
            <span>{{ msgSistema }}</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>
        
        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!--<div class="searchBar mt-1 mb-1" v-if="!flagLoading">
            <div class="elSearch">
                <v-autocomplete
                v-model="execSysPRE"
                :items="liExecSys"
                color="rgb(247,215,46)"
                class="w-100"
                @change="callSearch(execSysPRE)"
                ></v-autocomplete>

                <v-icon @click="callSearch(execSysPRE)"
                size="42"
                class="el_icon_search"
                @mouseover="hoverSearch = 'rgb(31,122,177)'"
                @mouseleave="hoverSearch = '#f39c12'"
                :style="{'color': hoverSearch,'align-self':'center'}">mdi-magnify</v-icon>
            </div>

            <div class="mt-4 ml-3 titSysSelected">Sistema selecionado</div>
            <div class="subTitSys">{{ execSys }}</div>
        </div>-->

        <!--<div class="lineBtns" v-if="!flagLoading && flagGrafV1">
            <v-chip color="#F39C12" @click="changeDateToday()">Hoje</v-chip>
            <v-chip class="ml-2" @click="changeDate()">Escolher data</v-chip>
        </div>

        <v-dialog v-model="flagDialog" max-width="250px">
            <div class="" v-if="flagDialog">

                <DialogExec v-if="flagDialog" :liDatas2conv2Date="liDatas2conv2Date" 
                @fromDialog="desableDialog($event)" 
                />

            </div>
        </v-dialog>-->

        <!-- TABELA ( V2 ) -->
        <div class="painelGeral" v-if="!flagLoading && flagTable && !flagMsgSistema">
            <!--<ExecExibTable :key="execSys" :execSys="execSys" :emailCliente="emailCliente" />-->
            <ExecView 
            :key="execSys"
            :execSys="execSys"
            :emailCliente="emailCliente"
            />
        </div>

    </div>
</template>

<script>
//import axios from 'axios'

import ExecView from './AgendExec/ExecView.vue'
//import ExecExibTable from './subExec/ExecExibTable'

export default {

    components:{ExecView/*, ExecExibTable*/},

    data() {
        return {

            // loading
            flagLoading:true,
            flagTable:false,

            flagMsgSistema:false, // condiciona busca se o sistema tiver sido selecionado no init.
            msgSistema:'Selecione um sistema na página "Início"',

            emailCliente:'',
            execSys:'', // -- sistema current exib
        }
    },

    methods:{

        initTableBySys() {

            // -- obter sistema atual selecionado.
            this.execSys = this.$store.state.sistemaSC

            // -- se sistema vazio, então não buscar o sistema...
            if (this.execSys == '') { this.flagMsgSistema = true; this.flagLoading = false; return; } 
            else { this.flagMsgSistema = false }

            // -- obter nome cliente logado (email).
            this.emailCliente = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025

            // -- habilitar exibição da tabela exec.
            this.flagLoading = false // -- desabilitar loading.
            this.flagTable = true // -- habilitar exibição tabela pipeline exec. (todas as versoes)
        },

    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { 

            if (execSys != 'aveleda1') { 
                this.flagMsgSistema = false
                this.initTableBySys() 
            } // nao ha dados recentes para o POC 2023
            else { 
                this.msgSistema = 'Agendamento indisponível para este sistema'
                this.flagLoading = false // -- desabilitar loading.
                this.flagMsgSistema = true
            } 
        }
    }
}
</script>